// tslint:disable: completed-docs
// Namespaces
const NAMESPACE = 'TARIFF_OVERVIEW';
export default NAMESPACE;
